import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import StudentInformationContent from "../../trainings/students/components/StudentInformationContent";
import { useAuthContext } from "../../../hooks/useAuthContext";
import AddStudentObservationModal from "../../trainings/students/components/AddStudentObservationModal";
import { PERMISSION_TRAINING_STUDENT_OBSERVATIONS } from "../../../permissions";

const FamilyInfoModal = forwardRef(({ schoolId, trainingId }, ref) => {
  const [visible, setVisible] = useState(false);
  const [student, setStudent] = useState(null);
  const [maximized, setMaximized] = useState(true);
  const { currentMembership, hasPermission } = useAuthContext();
  const addObservationModalRef = useRef(null);
  const canAddObservation = hasPermission(PERMISSION_TRAINING_STUDENT_OBSERVATIONS.CREATE);

  const show = (studentData) => {
    setStudent(studentData);
    setMaximized(true);
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
    setStudent(null);
  };

  useImperativeHandle(ref, () => ({
    show,
    hide,
  }));

  const header = (
    <div className="flex align-items-center gap-2">
      <i className="pi pi-id-card text-xl"></i>
      <span className="text-xl font-semibold">Informations de l'élève</span>
    </div>
  );

  const footer = (
    <div className="flex justify-content-end gap-2">
      {canAddObservation && (
        <Button
          label="Ajouter une observation"
          icon="pi pi-comment"
          outlined
          onClick={() => addObservationModalRef.current?.show(student)}
        />
      )}
      <Button label="Fermer" icon="pi pi-times" onClick={hide} className="p-button-text" />
    </div>
  );

  if (!student) return null;

  return (
    <Dialog
      visible={visible}
      onHide={hide}
      header={header}
      footer={footer}
      style={{ width: "80vw", maxWidth: "1200px" }}
      maximizable
      maximized={maximized}
      onMaximize={(e) => setMaximized(e.maximized)}
      className="family-info-modal"
    >
      <StudentInformationContent
        student={student}
        schoolId={schoolId}
        trainingId={trainingId}
        siblingLink="candidates"
        showHistory
        showStudentFileButton
        disableNavigation={currentMembership?.is_teacher}
      />
      <AddStudentObservationModal ref={addObservationModalRef} schoolId={schoolId} trainingId={trainingId} />
    </Dialog>
  );
});

export default FamilyInfoModal;
